import { render, staticRenderFns } from "./OrderPriceBox.vue?vue&type=template&id=14c6ae98&scoped=true&"
import script from "./OrderPriceBox.vue?vue&type=script&lang=js&"
export * from "./OrderPriceBox.vue?vue&type=script&lang=js&"
import style0 from "./OrderPriceBox.vue?vue&type=style&index=0&id=14c6ae98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c6ae98",
  null
  
)

export default component.exports